'use strict';
//signalrService MIGRADO
import Push from "push.js";

angular.module('TurneroApp').component('coSidebarAtencion', {
    controller: [
        '$interval',
        '$state',
        'agendaService',
        'puestosService',
        'utilsService',
        'usuariosService',
        'turnosService',
        '$localStorage',
        'signalrDotNetCoreService',
        'TurneroAppConstant',
        '$location',
        '$scope',
        '$timeout',
        function ($interval, $state, agendaService, puestosService, utilsService, usuariosService, turnosService, $localStorage, signalrService, TurneroAppConstant, $location, $scope, $timeout) {
            var ctrl = this;
            ctrl.TurnosEstados = TurneroAppConstant.Estados.Turno;
            ctrl.Modalidades = TurneroAppConstant.Modalidades;
            ctrl.Prioridades = TurneroAppConstant.Prioridades;
            ctrl.Derivacion = TurneroAppConstant.Derivacion;
            ctrl.Atencion = {
                Agenda: $localStorage.AgendaSeleccionada,
                Atencion: null,
                Puesto: $localStorage.PuestoSeleccionado
            };
            ctrl.Agendas = null;
            ctrl.Turnos = null;
            ctrl.PuestoPausado = false;
            ctrl.bloquearAcciones = false;
            ctrl.centroAtencionSeleccionado = $localStorage.centroAtencionSeleccionado;
            ctrl.usuarioConfig = $localStorage.TurneroApp_UsuarioSesion;
            ctrl.colaDerivacionPausa = [];
            ctrl.PuestoSeleccionado = $localStorage.PuestoSeleccionado;

            ctrl.$onInit = function () {
                //INICIALIZACION DEL COMPONENTE
                if (!ctrl.centroAtencionSeleccionado.id) {
                    $state.go('sidebar.sidebarAtencionConfig');
                }
            };

            ctrl.$onDestroy = function () {
                //cuando el componente se destruye se cancela el interval
                if (ctrl.intervalAccionesTemporizadas)
                    $interval.cancel(ctrl.intervalAccionesTemporizadas);

                if (ctrl.intervalTiemposDeEsperaExcedidosTemporizado)
                    $interval.cancel(ctrl.intervalTiemposDeEsperaExcedidosTemporizado);

                //cierro las conexiones activas
                ctrl.disconnectSignalr();
            };

            function refresh() {
                //Refrescar la pantalla
                $state.reload();
            }

            //RELOJ
            ctrl.tick = function () {
                //si no es la atencion cancela el interval
                if ($state.$current.name != "sidebar.sidebarAtencionListado") {
                    $interval.cancel(ctrl.tickerSengundero);
                } else {
                    //si estamos en atencion. actualiza la hora del reloj
                    ctrl.clock = Date.now();
                }
            }
            ctrl.tick();
            ctrl.tickerSengundero = $interval(function () {
                ctrl.tick()
            }, 1000);

            ctrl.HabilitarLlamarProximo = function () {
                //VALIDACIONES PARA SABER SI SE HABILITA EL LLAMAR PROXIMO
                //al retornar TRUE esta funcion deshabilita el btn Llamar proximo, por lo que, mientras todo este bien, deberia devolver FALSE.
                if (ctrl.Turnos && ctrl.usuarioConfig && ctrl.usuarioConfig.Llamador_Activo != undefined) {
                    var result = (!(ctrl.Turnos.length) && !(ctrl.usuarioConfig.Llamador_Activo)) || //Si no hay turnos y llamador activo es false
                        ctrl.bloquearAcciones || //si estan bloqueadas las acciones
                        (ctrl.Turnos.length && ctrl.usuarioConfig.Llamador_Activo && ctrl.TurnoAtendidoPorMi) // si existen turnos y el llamador_activo es true y TurnoAtendidoPorMi.value es TRUE
                    return result;
                }
                return true;
            }

            //ACCIONES TURNOS
            ctrl.llamarProximo = function () {
                //ACCIONES A REALIZAR CUANDO SE CLICKEA LLAMAR PROXIMO
                if (ctrl.Turnos.length) {//verifico si existen turnos.
                    ctrl.bloquearAcciones = true;
                    var Turno_Salteado = null;
                    var Turno_Llamado = null;
                    
                    // Obtener turnos con prioridad que esten esperando
                    var turnosConPrioridad = ctrl.Turnos.filter(function (turno) {
                        return turno.Id_Estado == ctrl.TurnosEstados.Anunciado && turno.Prioridad_Turno == ctrl.Prioridades.Muy_Alta || turno.Prioridad_Turno == ctrl.Prioridades.Alta;
                    });
                    
                    for (var i = 0; i < ctrl.Turnos.length; i++) {
                        var turno = ctrl.Turnos[i]; //cada turno
                        //si hay solo un turno, esta llamado y lo llame yo
                        if (ctrl.Turnos.length == 1 && turno.Id_Estado == ctrl.TurnosEstados.Llamado && turno.Id_Centro_Usuario == ctrl.usuarioConfig.Id_Centro_Usuario) {
                            Turno_Llamado = turno; //asigno el turno a turno llamado
                        }
                        // Si hay turnos con prioridad, y no se esta llamando a una prioridad. Llamo a la prioridad y pongo en espera al llamado anteriormente
                        if (turnosConPrioridad.length > 0 && turno.Id_Estado == ctrl.TurnosEstados.Llamado && turno.Id_Centro_Usuario == ctrl.usuarioConfig.Id_Centro_Usuario && turno.Prioridad_Turno != ctrl.Prioridades.Muy_Alta && turno.Prioridad_Turno != ctrl.Prioridades.Alta) {
                            Turno_Salteado = turno;
                            Turno_Llamado = turnosConPrioridad[0];
                        } else if (turno.Id_Centro_Usuario == ctrl.usuarioConfig.Id_Centro_Usuario) { // si esta asignado ami
                            //si esta llamado y se lo llamo 2 o mas veces
                            if ((turno.Id_Estado == ctrl.TurnosEstados.Llamado) && turno.Cant_Llamados >= 2) {
                                Turno_Salteado = turno; // lo salteo
                            }
                            //si todavia no llega a las 2 veces
                            if ((turno.Id_Estado == ctrl.TurnosEstados.Llamado) && turno.Cant_Llamados < 2) {
                                Turno_Llamado = turno;
                            }
                        }
                    }

                    if (Turno_Llamado) {// si tengo algo en "Turno_Llamado", es porque tengo que llamar al turno
                        ctrl.llamarTurno(Turno_Llamado, false);
                    } else {
                        for (var i = 0; i < ctrl.Turnos.length; i++) {
                            turno = ctrl.Turnos[i];
                            /*Si el (turno estan en estado anunciado  O  estan derivados ami  o estan retenidos por mi ) Y
                             * Turno_Salteado no tiene datos  o el id_turno es distinto al de Turno_Salteado*/
                            if ((turno.Id_Estado == ctrl.TurnosEstados.Anunciado ||
                                    turno.Id_Estado == ctrl.TurnosEstados.Derivado && ctrl.validarDerivadoAMi(turno)) &&
                                (!Turno_Salteado || turno.Id_Turno != Turno_Salteado.Id_Turno)) {
                                //Llama el turno
                                ctrl.llamarTurno(turno, false);
                                break;
                            }
                        }
                    }
                    if (Turno_Salteado) {
                        //Si Turno_Salteado no esta vacio, entonces volver el turno al estado anterior
                        ctrl.volverEstadoAnterior(Turno_Salteado);
                    }
                    
                    //refrescar la grilla de turnos después de llamar próximo
                    $timeout(function() {
                        ctrl.getAtencionGrilla();
                    }, 500);
                    ctrl.bloquearAcciones = false;
                }
            };

            ctrl.arrayTurnosVolverEstado = [];

            ctrl.volverEstadoAnterior = function (turno) {
                //PASA UN TURNO  AL ESTADO ANTERIOR
                //valido si el turno ya se encuentra en el array para volver atras el estado
                if (ctrl.arrayTurnosVolverEstado.indexOf(turno.Id_Turno) == -1) { //cuando indexOf devuelve -1 es porque no lo encontro
                    //este valor lo guardo para que no se pierda en las acciones asíncronas al cambiar de agenda
                    let idUsuarioSesion = ctrl.usuarioConfig.Id_Usuario_Sesion;
                    //lo agrega al array.
                    ctrl.arrayTurnosVolverEstado.push(turno.Id_Turno)

                    //vuelvo el turno al estado anterior
                    turnosService.Cambiar_Estado_Turno_Anterior({
                        'Id_Turno': turno.Id_Turno
                    }).$promise.then(function () {
                        // lo quito del array
                        ctrl.arrayTurnosVolverEstado.splice(ctrl.arrayTurnosVolverEstado.indexOf(turno.Id_Turno), 1)

                        //elimino el turno del llamador
                        signalrService.startHub(TurneroAppConstant.HubNames.LLAMADOR).then(function (hub) {
                            hub.invoke('EliminarTurno', turno.Id_Turno, ctrl.centroAtencionSeleccionado.id).then(function () {
                                console.info("Se invocó a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + " para el turno " + turno.Id_Turno + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + " para el turno " + turno.Id_Turno + ": " + err.toString());
                            });

                        });

                        //actualizo ese turno
                        signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                            hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, turno.Id_Turno).then(function () {
                                console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ": " + err.toString());
                            });
                        });
                        
                        //refrescar la grilla de turnos después de un breve delay
                        $timeout(function() {
                            ctrl.getAtencionGrilla();
                        }, 500);
                    }).catch(function (error) {
                        utilsService.errores(error);
                        ctrl.limpiarMemoria();
                    })
                }
            }

            ctrl.volverTurnosLlamados = function (Id_TurnoLlamado) {
                //de todos los turnos llamados por el usuario exceptuando el que viene por parametro vuelven al estado anterior
                if (ctrl.Turnos) {
                    for (var i = 0; i < ctrl.Turnos.length; i++) {
                        let turno = ctrl.Turnos[i];

                        if (turno.Id_Turno != Id_TurnoLlamado && turno.Id_Estado == ctrl.TurnosEstados.Llamado &&
                            turno.Id_Centro_Usuario == ctrl.usuarioConfig.Id_Centro_Usuario) {
                            ctrl.volverEstadoAnterior(turno);
                        }
                    }
                }
            }

            ctrl.llamarTurno = function (turno, bool) {
                //PASA UN TURNO  A ESTADO LLAMADO
                ctrl.bloquearAcciones = true;

                turnosService.Llamar_Turno({
                    'Id_Turno': turno.Id_Turno,
                    'id_usuario_sesion': ctrl.usuarioConfig.Id_Usuario_Sesion,
                    'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                }).$promise.then(function (resultado) {
                    //bloquea los botones de accion hasta que terminen los request 
                    ctrl.bloquearAcciones = false;

                    //envia la señal al llamador para que llame al turno
                    signalrService.startHub(TurneroAppConstant.HubNames.LLAMADOR).then(function (hub) {
                        hub.invoke('LlamarTurno', turno.Id_Turno, ctrl.centroAtencionSeleccionado.id).then(function () {
                            console.info("Se invocó a LlamarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + " para el turno " + turno.Id_Turno + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a LlamarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + " para el turno " + turno.Id_Turno + ": " + err.toString());
                        });
                    });

                    //actualizo este turno
                    signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                        hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, turno.Id_Turno).then(function () {
                            console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ": " + err.toString());
                        });
                    });

                    swal({
                        title: turno.Cant_Llamados == 0 ? 'Llamado en curso' : 'Reiterando llamado',
                        html: "Llamando a " + turno.N_Persona + " por puesto '" + ctrl.usuarioConfig.Puesto.text + "'." + (turno.Cant_Llamados > 0 ? '<br/><br/>Este turno ha sido llamado ' + (turno.Cant_Llamados + 1) + ' veces.' : ''),
                        type: 'success',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: "Aceptar",
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    });

                    //si se llamaron a otros turnos se vuelven al estado anterior
                    if (bool) {
                        ctrl.volverTurnosLlamados(turno.Id_Turno);
                    }
                    
                    //refrescar la grilla de turnos después de un breve delay para que el backend procese
                    $timeout(function() {
                        ctrl.getAtencionGrilla();
                    }, 500);
                }).catch(function (error) {
                    if (error.data && error.data.IsUserSessionException) {
                        utilsService.errores(error, refresh);
                    } else {
                        utilsService.errores(error);
                    }
                    ctrl.bloquearAcciones = false;
                    ctrl.limpiarMemoria();
                });
            };

            ctrl.perderTurno = function (turno) {
                //PASA UN TURNO  A ESTADO PERDIDO
                //bloqueo botones de acciones
                ctrl.changeBloquearAcciones(true);
                //validar que la sesion siga vigente

                let msgPromise = turnosService.Get_Turnos_Mensaje({
                    'Id_Turno': turno.Id_Turno,
                    'Id_Estado': turno.Id_Estado
                });

                msgPromise.$promise.catch(function (error) {
                    ctrl.loadingViewInfo = false;
                    ctrl.changeBloquearAcciones(false);
                    utilsService.errores(error);

                    if (error.data && error.data.IsUserSessionException) {
                        ctrl.limpiarMemoria();
                    }
                });

                msgPromise.$promise.then(function (resultado) {
                    var info = resultado.Data;

                    /*Este Metodo setea el turno como Perdido, pero como es una accion irreversible necesita de la confirmacion del usuario.*/
                    swal({
                        title: 'Marcar turno como perdido',
                        html: '¿Confirma que desea marcar como perdido el turno ' + turno.Id_Turno + ' a nombre de ' + turno.N_Persona + ' ? <br/><br/>El turno ha sido llamado ' + turno.Cant_Llamados + ' veces, a partir de las ' + info.Hora.split(":")[0] + ":" + info.Hora.split(":")[1] + ' hs. <br/><br/><span class="text-danger">Esta acción es irreversible.</span>',
                        type: 'warning',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        showCancelButton: true,
                        confirmButtonColor: '#004b81',
                        cancelButtonColor: 'rgb(170, 170, 170)',
                        confirmButtonText: "Aceptar",
                        cancelButtonText: "Cancelar",
                    }).then(function () {
                        turnosService.Put_Turno_Estado({
                            'id_estado': ctrl.TurnosEstados.Perdido,
                            'id_turno': turno.Id_Turno,
                            'hacer_commit': 1,
                            'id_usuario_sesion': ctrl.usuarioConfig.Id_Usuario_Sesion,
                            'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                        }).$promise.then(function (resultado) {
                            //habilita los botones
                            ctrl.changeBloquearAcciones(false);

                            //elimina el turno del llamador
                            signalrService.startHub(TurneroAppConstant.HubNames.LLAMADOR).then(function (hub) {
                                hub.invoke('EliminarTurno', turno.Id_Turno, ctrl.centroAtencionSeleccionado.id).then(function () {
                                    console.info("Se invocó a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ".");
                                }).catch(function (err) {
                                    console.error("Falló invocación a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ": " + err.toString());
                                });
                            });

                            //actualizo ese turno
                            signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                                hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, turno.Id_Turno).then(function () {
                                    console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ".");
                                }).catch(function (err) {
                                    console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ": " + err.toString());
                                });
                            });

                            swal({
                                title: 'Turno perdido',
                                html: "Se ha marcado el turno como perdido.",
                                type: 'success',
                                confirmButtonColor: '#004b81',
                                confirmButtonText: "Aceptar"
                            });
                            
                            //refrescar la grilla de turnos después de un breve delay para que el backend procese
                            $timeout(function() {
                                ctrl.getAtencionGrilla();
                            }, 500);
                        }).catch(function (error) {
                            if (error.data && error.data.IsUserSessionException) {
                                utilsService.errores(error, refresh);
                            } else {
                                utilsService.errores(error);
                            }
                            ctrl.changeBloquearAcciones(false);
                            ctrl.limpiarMemoria();
                        })
                    }, function (error) {
                        swal.close();
                        ctrl.changeBloquearAcciones(false);
                    });
                });
            }

            //Atender button
            ctrl.atenderTurno = function (turno) {
                //PASA UN TURNO  A ESTADO ATENDIDO
                //bloqueo botones de acciones
                ctrl.changeBloquearAcciones(true);
                //si el estado del turno no es Atendido
                if (ctrl.TurnosEstados.Atendido != turno.Id_Estado) {
                    //Cambio el estado del turno
                    turnosService.Put_Turno_Estado({
                        'id_estado': ctrl.TurnosEstados.Atendido,
                        'id_turno': turno.Id_Turno,
                        'hacer_commit': 1,
                        'id_usuario_sesion': ctrl.usuarioConfig.Id_Usuario_Sesion,
                        'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                    }).$promise.then(function (resultado) {
                        ctrl.changeBloquearAcciones(false);

                        //actualizo este turno
                        signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                            hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, turno.Id_Turno).then(function () {
                                console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ": " + err.toString());
                            });
                        });

                        //quito el turno del llamador
                        signalrService.startHub(TurneroAppConstant.HubNames.LLAMADOR).then(function (hub) {
                            hub.invoke('EliminarTurno', turno.Id_Turno, ctrl.centroAtencionSeleccionado.id).then(function () {
                                console.info("Se invocó a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ": " + err.toString());
                            });
                        });

                        //seteo último turno atendido
                        signalrService.startHub(TurneroAppConstant.HubNames.LLAMADOR).then(function (hub) {
                            hub.invoke('UltimoTurnoAtendido', turno.Id_Turno, ctrl.centroAtencionSeleccionado.id).then(function () {
                                console.info("Se invocó a UltimoTurnoAtendido en " + TurneroAppConstant.HubNames.LLAMADOR + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a UltimoTurnoAtendido en " + TurneroAppConstant.HubNames.LLAMADOR + ": " + err.toString());
                            });
                        });

                        //actualiza el puesto actual
                        signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                            hub.invoke('TraerPuesto', ctrl.centroAtencionSeleccionado.id, $localStorage.TurneroApp_UsuarioSesion.Puesto.id).then(function () {
                                console.info("Se invocó a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                            });
                        });
                        
                        //refrescar la grilla de turnos después de un breve delay para que el backend procese
                        $timeout(function() {
                            ctrl.getAtencionGrilla();
                        }, 500);
                    }).catch(function (error) {
                        if (error.data && error.data.IsUserSessionException) {
                            utilsService.errores(error, refresh);
                        } else {
                            utilsService.errores(error);
                        }
                        ctrl.changeBloquearAcciones(false);
                        ctrl.limpiarMemoria();
                    });
                } else {
                    //Si el turno ya estaba en estado atendido, solo desbloqueo las acciones
                    ctrl.changeBloquearAcciones(false);
                }
            };

            ctrl.traerTurnos = function (id_centro_atencion) {
                // El usuario tiene que tener un Id_usuario _sesion (y el centro debe ser el seleccionado <-- esto está verificado por el grupo de conexión del hub)
                if (ctrl.usuarioConfig && ctrl.usuarioConfig.Id_Usuario_Sesion) {
                    //se actualiza la grilla
                    ctrl.getAtencionGrilla();
                }
                else {
                    ctrl.disconnectSignalr();
                    ctrl.limpiarMemoria();
                    swal({
                        title: 'Cierre de Atención',
                        html: 'Su sesión de atención ha finalizado exitosamente.',
                        type: 'success',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: "Ok",
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    })
                    ctrl.bloquearAcciones = false;
                }
            };

            ctrl.traerTurnoDerivacion = function (derivacion) {
                //si el puesto se encuentra pausado se agrega a la cola
                if (ctrl.PuestoPausado) {
                    ctrl.colaDerivacionPausa.push(derivacion);
                }
                else {
                    //los datos de la derivacion van a la funcion que muestra el modal
                    let prom = ctrl.DerivacionModal(derivacion);

                    if (prom)
                        prom.catch(swal.noop);
                }
            };

            ctrl.mostrarDerivacionesEnCola = function () {
                for (let i in ctrl.colaDerivacionPausa) {
                    //muestro el mensaje de derivación
                    let swalPromise = ctrl.DerivacionModal(ctrl.colaDerivacionPausa[i]);

                    //si es un swal espero hasta que se cierre para continuar con la cola
                    if (swalPromise) {
                        swalPromise.then(function () {
                            //elimino los elementos que ya fueron notificados
                            ctrl.colaDerivacionPausa.splice(0, i + 1);
                            // llamo recursivamente
                            ctrl.mostrarDerivacionesEnCola();
                        });
                        return;
                    }
                }
            };

            ctrl.mostrarTurnoAtencion = function (turno) {
                //console.log('turnos: ', ctrl.Turnos);
                //console.log('turno: ', turno);
                if (ctrl.Turnos && turno) {
                    var indx = ctrl.Turnos.findIndex(x => x.Id_Turno == turno.Id_Turno);

                    //valido si solo se deben mostrar los turnos asignados al box.
                    if (ctrl.usuarioConfig && ctrl.usuarioConfig.soloTurnosBoxActual)
                        var valMostrar = ctrl.validarTurnoParaMiPuesto(turno);
                    //verifico si está derivado a mi (sin importar el estado del turno ni la agenda seleccionada si es por grupo o puesto)
                    else if (ctrl.validarDerivadoAMi(turno))
                        var valMostrar = true;
                    //si está en estado derivado pero no es a mi
                    else if (turno.Id_Estado == ctrl.TurnosEstados.Derivado)
                        var valMostrar = false;
                    //verifico si pertenece a la agenda seleccionada
                    else
                        var valMostrar = ctrl.validarAgendaTurno(turno);

                    //console.log('index: ', indx, 'mostrar: ', valMostrar);

                    //si encuentra el turno y no lo debo mostrar, entoces lo quito
                    if (indx != -1 && !valMostrar) {
                        ctrl.Turnos.splice(indx, 1);

                        //Elimino la notificación Push si existe
                        Push.close(turno.Id_Turno);
                    }
                    //si encuentra el turno lo modifica
                    else if (indx != -1)
                        ctrl.Turnos[indx] = turno;
                    //si no lo encuentra pero debe mostrarlo lo agrega
                    else if (valMostrar) {
                        ctrl.Turnos.push(turno);
                        ctrl.notificacionPushAnunciado(turno);
                    }

                    ctrl.validarTurnoAtendidoPorMi();

                    //ordeno el array según prioridad (- o + para descendente o ascendente respectivamente)
                    //se va a hacer en el html para que se actualice constantemente
                    //ctrl.Turnos = $filter('orderBy')(ctrl.Turnos, ['+Prioridad_Turno', '+Prioridad_Tramite', ctrl.ordenFechaTurno, '+Fecha_Anunciado_Derivado', '+Fec_Turno']);
                }
                else {
                    //se actualiza la grilla
                    ctrl.traerTurnos();
                }
            };

            ctrl.notificacionPushAnunciado = function (turno) {
                if (ctrl.usuarioConfig.notificarNuevosTurnos) {
                    if (Push.Permission.DEFAULT) {
                        Push.Permission.request(ctrl.mostrarNotificacion(turno), ctrl.mensajePermisosNotificacion);
                    }
                    else if (Push.Permission.DENIED) {
                        ctrl.mensajePermisosNotificacion();
                    }
                }
            }

            ctrl.mostrarNotificacion = function (turno) {
                var urlIcon = '';

                if (turno.Sujeto_Ley_9131 == 'E')
                    urlIcon = 'assets/img/pregnant-woman.png'
                else if (turno.Sujeto_Ley_9131 == 'D')
                    urlIcon = 'assets/img/wheelchair-access.png'
                else if (turno.Sujeto_Ley_9131 == 'A')
                    urlIcon = 'assets/img/man-with-cane.png'

                Push.create('¡Nuevo turno anunciado!', {
                    body: turno.N_Persona + " está esperando ser atendido.",
                    tag: turno.Id_Turno,
                    icon: urlIcon,
                    link: 'atencion',
                    onClick: function () {
                        window.focus();
                        this.close();
                    }
                });
            }

            ctrl.notificacionTiempoEsperaExcedidoPush = function (agendas) {
                if (ctrl.usuarioConfig.notificarTiempoEsperaExcedido) {
                    if (Push.Permission.DEFAULT) {
                        Push.Permission.request(ctrl.mostrarNotificacionTiempoEsperaExcedido(agendas), ctrl.mensajeTiempoEsperaExcedido);
                    }
                    else if (Push.Permission.DENIED) {
                        ctrl.mensajeTiempoEsperaExcedido();
                    }
                }
            }

            ctrl.mostrarNotificacionTiempoEsperaExcedido = function (agendas) {
                var urlIcon = 'assets/img/tiempo-espera-excedido.png';

                Push.create('¡Tiempo de Espera Excedido!', {
                    body: "Existen turnos con tiempos de espera excedidos.",
                    icon: urlIcon,
                    link: 'atencion',
                    onClick: function () {
                        window.focus();
                        this.close();
                    }
                });
            }

            ctrl.onChangeNotificacionPush = function () {
                if (ctrl.usuarioConfig.notificarNuevosTurnos) {
                    if (Push.Permission.DEFAULT) {
                        Push.Permission.request(ctrl.permisoNotificacionOtorgado, ctrl.mensajePermisosNotificacion);
                    }
                    else if (Push.Permission.DENIED) {
                        ctrl.mensajePermisosNotificacion();
                    }
                } else {
                    ctrl.permisoNotificacionOtorgado();
                }
            }

            ctrl.permisoNotificacionOtorgado = function () {
                usuariosService.Post_Claim_Notificar_Nuevos_Turnos({
                    'notificarNuevosTurnos': ctrl.usuarioConfig.notificarNuevosTurnos
                }).$promise.then(function () {
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }

            ctrl.mensajePermisosNotificacion = function () {
                ctrl.usuarioConfig.notificarNuevosTurnos = false;
                ctrl.permisoNotificacionOtorgado();

                ctrl.mostrarMensajeSolicitandoPermisos();
            }

            ctrl.onChangeTiempoEsperaExcedidoPush = function () {
                if (ctrl.usuarioConfig.notificarTiempoEsperaExcedido) {
                    if (Push.Permission.DEFAULT) {
                        Push.Permission.request(ctrl.permisoNotificacionTiempoEsperaExcedidoOtorgado, ctrl.mensajeTiempoEsperaExcedido);
                    }
                    else if (Push.Permission.DENIED) {
                        ctrl.mensajeTiempoEsperaExcedido();
                    }
                } else {
                    ctrl.permisoNotificacionTiempoEsperaExcedidoOtorgado();

                }
            }

            ctrl.permisoNotificacionTiempoEsperaExcedidoOtorgado = function () {
                usuariosService.Post_Claim_Notificar_Tiempo_Espera_Excedido({
                    'notificarTiempoEsperaExcedido': ctrl.usuarioConfig.notificarTiempoEsperaExcedido
                }).$promise.then(function () {
                    if (ctrl.usuarioConfig.notificarTiempoEsperaExcedido)
                    {
                        ctrl.activarControlTiemposDeEsperaExcedidos();
                    }
                    else
                    {
                        ctrl.desactivarControlTiemposDeEsperaExcedidos();
                    }
                }).catch(function (error) {
                    ctrl.desactivarControlTiemposDeEsperaExcedidos();
                    utilsService.errores(error);
                });
            }

            ctrl.mensajeTiempoEsperaExcedido = function () {
                ctrl.usuarioConfig.notificarTiempoEsperaExcedido = false;
                ctrl.permisoNotificacionTiempoEsperaExcedidoOtorgado();

                ctrl.mostrarMensajeSolicitandoPermisos();
            }

            ctrl.mostrarMensajeSolicitandoPermisos = function ()
            {
                swal({
                    title: 'Activar Permisos de Notificación',
                    html: 'Tiene que activar desde su navegador los permisos para poder recibir notificaciones de esta página.',
                    type: 'warning',
                    confirmButtonColor: '#004b81',
                    confirmButtonText: "Ok",
                    allowEscapeKey: false,
                    allowOutsideClick: false
                })
            }

            ctrl.ordenFechaTurno = function (v1) {
                if (v1.Fec_Turno) {
                    let f1 = new Date(v1.Fec_Turno);
                    let f2 = new Date();

                    //si la hora del turno reservado ya pasó, entonces el turno tiene prioridad
                    if (v1.Id_Modalidad != ctrl.Modalidades.Orden_de_Llegada && f1 < f2) {
                        return -1;
                    }

                    return 0;
                }

                return 1;
            }

            ctrl.quitarTurnoAtencion = function (Id_Turno) {
                //console.log('quitar turno: ', Id_Turno);
                if (ctrl.Turnos && Id_Turno) {
                    var indx = ctrl.Turnos.findIndex(x => x.Id_Turno == Id_Turno);
                    //console.log('index: ', indx);

                    //si encuentra el turno lo quita
                    if (indx != -1)
                        ctrl.Turnos.splice(indx, 1);

                    ctrl.validarTurnoAtendidoPorMi();

                    //Elimino la notificación Push si existe
                    Push.close(Id_Turno);
                }
                else {
                    //se actualiza la grilla
                    ctrl.traerTurnos();
                }
            };

            ctrl.SignalRConnect = function (callback) {
                //se genera la conexion
                //signalrService.connect(true, function () {
                signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                    ctrl.signalrActive = true;
                    //se obtiene la conexion
                    ctrl.connection = hub; //signalrService.getConnection();
                    //crea los hubs para utilizarlos 
                    //LlamadorHub = signalrService.createHubProxy('LlamadorHub'); < -no se usaba
                    TurnosHub = hub //signalrService.createHubProxy('TurnosHub');

                    //define lo que se ejecuta cuando TurnosHub ejecute TraerTurnos
                    TurnosHub.on("TraerTurnos", ctrl.traerTurnos);

                    //define lo que se ejecuta cuando TurnosHub ejecute TraerTurnoDerivacion
                    TurnosHub.on("TraerTurnoDerivacion", ctrl.traerTurnoDerivacion);

                    //define lo que se ejecuta cuando TurnosHub ejecute TraerTurnoAtencion
                    TurnosHub.on("MostrarTurnoAtencion", ctrl.mostrarTurnoAtencion);

                    //define lo que se ejecuta cuando TurnosHub ejecute QuitarTurnoAtencion
                    TurnosHub.on("QuitarTurnoAtencion", ctrl.quitarTurnoAtencion);

                    //a TurnosHub lo agrega al Grupo del centro de atencion.
                    TurnosHub.invoke('AgregarGrupo', ctrl.centroAtencionSeleccionado.id).then(function () {
                        console.info("Se invocó a AgregarGrupo en " + TurneroAppConstant.HubNames.TURNOS + ".");
                    }).catch(function (err) {
                        console.error("Falló invocación a AgregarGrupo en " + TurneroAppConstant.HubNames.TURNOS + ": " + err.toString());
                    });

                    //si exisitese alguna funcion que ejecutar a modo callback la ejecuto
                    if (callback) callback();
                }).catch(function () {
                    //si no se pudo conectar al hub en primera instancia activo las acciones temporizadas
                    ctrl.activarAccionesTemporizadas();
                });
            }

            ctrl.disconnectSignalr = function () {
                // desconecta signalR
                ctrl.signalrActive = false;

                signalrService.stopHub(TurneroAppConstant.HubNames.TURNOS);
                signalrService.stopHub(TurneroAppConstant.HubNames.PUESTOS);
                signalrService.stopHub(TurneroAppConstant.HubNames.LLAMADOR);
            }

            ctrl.limpiarMemoria = function () {
                ctrl.Atencion = {
                    Agenda: null,
                    Atencion: null
                };
                ctrl.Agendas = null;
                ctrl.Turnos = null;
                delete ($localStorage.TurneroApp_UsuarioSesion)
                delete $localStorage.AgendaSeleccionada
                delete $localStorage.PuestoSeleccionado
                $location.path("/sidebar/atencion/seleccion")
            }

            ctrl.salir = function () {
                ctrl.bloquearAcciones = true;

                usuariosService.Post_Salir_Atencion({
                    'id_usuario_sesion': ctrl.usuarioConfig.Id_Usuario_Sesion,
                    'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                }).$promise.then(function (resultado) {
                    //actualizo el estado del puesto en estados puesto atencion
                    signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                        hub.invoke('TraerPuesto', ctrl.centroAtencionSeleccionado.id, ctrl.usuarioConfig.Puesto.id).then(function () {
                            console.info("Se invocó a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                        });
                    });
                    
                    //actualizo los turnos asignados al centro de atencion
                    signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                        console.log(hub)
                        hub.invoke('TraerTurnos', ctrl.centroAtencionSeleccionado.id).then(function () {
                            console.info("Se invocó a TraerTurnos en " + TurneroAppConstant.HubNames.TURNOS + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerTurnos en " + TurneroAppConstant.HubNames.TURNOS + ": " + err.toString());
                        });
                    });
                    
                    //borramos el id_ususario_sesion y hacemos que se actualicen las grillas de todos, por los turnos derivados
                    ctrl.usuarioConfig.Id_Usuario_Sesion = null;
                    
                    //desconecta, limpia y muestra mensaje de que se desconecto correctamente
                    ctrl.limpiarMemoria();

                    swal({
                        title: 'Cierre de Atención',
                        html: 'Su sesión de atención ha finalizado exitosamente.',
                        type: 'success',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: "Ok",
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    })
                    ctrl.bloquearAcciones = false;
                }).catch(function (error) {
                    //Cualquier cosa que falle limpia la sesion
                    swal.close();
                    if (error.data && error.data.IsUserSessionException) {
                        utilsService.errores(error, refresh);
                    } else {
                        utilsService.errores(error);
                    }
                    ctrl.bloquearAcciones = false;
                    ctrl.limpiarMemoria();
                });
            };

            ctrl.salirConfirmacion = function () {
                swal({
                    title: 'Cierre de Atención',
                    html: '¿Confirma que desea finalizar su sesión de atención? <br/><br/>Los turnos que se hayan derivado a su box se derivarán automáticamente a la agenda en la que se encuentra conectado.',
                    type: 'info',
                    showCancelButton: true,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    confirmButtonColor: '#004b81',
                    cancelButtonColor: 'rgb(170, 170, 170)',
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Cancelar",
                }).then(function () {
                    ctrl.salir();
                }).catch(function (error) {
                    if (error != "cancel") {
                        utilsService.errores(error);
                        ctrl.limpiarMemoria();
                    }
                    swal.close();
                })
            };

            ctrl.pausarAtencion = function () {
                //esta bandera se creo para que cuando el puesto este pausadoi
                ctrl.PuestoPausado = false;
                ctrl.bloquearAcciones = true;
                /*al llegar a esta instancia se pausara la atencion*/
                puestosService.Put_Pausar_Puestos({
                    'id_usuario_sesion': ctrl.usuarioConfig.Id_Usuario_Sesion,
                    'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                }).$promise.then(function () {
                    //cuando todo salio bien la bandera de PuestoPausado se pone en true.
                    ctrl.PuestoPausado = true;
                    //Se actualiza el puesto en estado puesto salon
                    signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                        hub.invoke('TraerPuesto', ctrl.centroAtencionSeleccionado.id, ctrl.usuarioConfig.Puesto.id).then(function () {
                            console.info("Se invocó a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                        });
                    });
                    ctrl.msgPausarAtencion();
                }).catch(function (error) {
                    ctrl.PuestoPausado = false;
                    //Cualquier cosa que falle limpia la sesion
                    if (error.data && error.data.IsUserSessionException) {
                        utilsService.errores(error, refresh);
                    } else {
                        utilsService.errores(error);
                    }
                    ctrl.bloquearAcciones = false;
                    ctrl.limpiarMemoria();
                });
            };
            
            ctrl.msgPausarAtencion = function () {
                swal({
                    title: 'Sesión en pausa',
                    html: 'La atención está pausada. Haga click en el botón Continuar atención para finalizar la pausa.',
                    type: 'info',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    confirmButtonColor: '#004b81',
                    confirmButtonText: "Continuar Atención",
                }).then(function () {
                    //SOLO CUANDO clickea "Continuar Atencion" se ejecuta el api de despausar
                    puestosService.Put_Despausar_Puestos(ctrl.usuarioConfig.Id_Usuario_Sesion).$promise.then(function () {
                        ctrl.PuestoPausado = false;
                        //Se actualiza el puesto en estado puesto salon
                        signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                            hub.invoke('TraerPuesto', ctrl.centroAtencionSeleccionado.id, ctrl.usuarioConfig.Puesto.id).then(function () {
                                console.info("Se invocó a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                            });
                        });
                        ctrl.bloquearAcciones = false;
                        swal.close();
                        //si hubo alguna derivación mientras estaba en pausa las muestra.
                        ctrl.mostrarDerivacionesEnCola();
                    }).catch(function (error) {
                        swal.close();
                        utilsService.errores(error);
                        ctrl.limpiarMemoria();
                    });
                }, function (error) {
                    ctrl.PuestoPausado = false;
                    swal.close();
                    console.log("error ", error)
                    utilsService.errores(error);
                });
            };

            ctrl.tiempoEsperaReferencia = function () {
                //Este metodo muestra el popup con la explicacion de los circulos de colores al lado del tiempo de espera
                var htmltext = '<div class="text-left"><span class="text-success"><i class="fa fa-circle-o"></i></span> = La persona se anunció antes del horario de su turno.<br/><span class="text-success"><i class="fa fa-circle"></i></span> = La persona se anunció a horario y está esperando atención.<br/><span class="text-warning"><i class="fa fa-circle"></i></span> = La persona ha esperado por al menos la duración de un turno.<br/><span class="text-danger"><i class="fa fa-circle"></i></span> = La persona ha esperado por al menos la duración de dos turnos.</div>'
                swal({
                    title: 'Espera - Referencia de color',
                    html: htmltext,
                    type: 'info',
                    confirmButtonColor: '#004b81',
                    confirmButtonText: "Aceptar",
                    allowEscapeKey: false,
                    allowOutsideClick: false
                })
            }

            ctrl.validarTiempoDeEspera = function (turno) {
                //esta funcion valida el tiempo de espera
                if (moment(turno.Fecha_Anunciado_Derivado, "YYYY-MM-DD HH:mm:ss") < moment(turno.Fec_Turno, "YYYY-MM-DD HH:mm:ss") &&
                    turno.Id_Estado == ctrl.TurnosEstados.Anunciado && //si la fecha de anunciado_derivado es menor a la fecha del turno. y esta anunciado
                    moment(moment().format("YYYY-MM-DD HH:mm:ss")).diff(moment(turno.Fec_Turno, "YYYY-MM-DD HH:mm:ss"), 'm')) { // y la diferencia en minutos sea mayor a 0

                    var fecha1 = moment(turno.Fec_Turno, "YYYY-MM-DD HH:mm:ss");

                    // obtengo cuanto ha pasado en minutos desde la fecha del turno hasta el momento
                    return moment(moment().format("YYYY-MM-DD HH:mm:ss")).diff(fecha1, 'm');
                    //ES DECIR ESTO SOLO VA A PASAR CUANDO EL TURNO ESTE ANUNCIADO Y YA SEA LA HORA DEL TURNO.
                    //SI EL CIUDADANO SE ANUNCIA ANTES DE LA FECHA DEL TURNO, ESTON NO VA A PASAR HASTA QUE SEA TIEMPO DE SER ATENDIDO
                } else {
                    var fecha1 = moment(turno.Fecha_Anunciado_Derivado, "YYYY-MM-DD HH:mm:ss");

                    // OBTIENE LA DIFERNCIA DE TIEMPO DESDE LA FECHA DE ANUNCIADO_DERIVADO
                    return moment(moment().format("YYYY-MM-DD HH:mm:ss")).diff(fecha1, 'm');
                }

            };

            ctrl.calcTiempoLlamado = function (turno) {
                //Obtiene el valor de cuantos minutos pasaron desde que se lo llamo (en minutos)
                var fecha1 = moment(turno.Fecha_Estado, "YYYY-MM-DD HH:mm:ss");
                return moment(moment().format("YYYY-MM-DD HH:mm:ss")).diff(fecha1, 'm');
            };

            ctrl.turnosEnEspera = function (id_agenda, logout) {
                ctrl.EnEspera = {
                    Sin_Turno: 0,
                    Con_Turno: 0,
                    Total: 0
                };
                if (ctrl.Turnos) {

                    for (var i = 0; i < ctrl.Turnos.length; i++) {
                        var turno = ctrl.Turnos[i];
                        turno.tiempoEspera = ctrl.validarTiempoDeEspera(turno);// a cada turno le asigna su tiempo de espera

                        if (turno.Id_Estado == ctrl.TurnosEstados.Anunciado ||//Si estuviese anunciado
                            (turno.Id_Estado == ctrl.TurnosEstados.Retenido && turno.Id_Centro_Usuario == ctrl.usuarioConfig.Id_Centro_Usuario) || //o retenido y por mi 
                            (turno.Id_Estado == ctrl.TurnosEstados.Derivado && ctrl.validarDerivadoAMi(turno))) { //O derivado y la derivacion sea hacia mi

                            if (turno.Id_Modalidad == ctrl.Modalidades.Orden_de_Llegada) {
                                ctrl.EnEspera.Sin_Turno = ctrl.EnEspera.Sin_Turno + 1;
                            } else {
                                //si no es orden de llegada, es porque tenia turno
                                ctrl.EnEspera.Con_Turno = ctrl.EnEspera.Con_Turno + 1;
                            }
                        }

                        //Esto puede pasar cuando el usuario cambia de agenda, y entonces todos los llamados que tiene tienen que volver al estado anterior
                        if (id_agenda && id_agenda != turno.Id_Agenda &&
                            turno.Id_Estado == ctrl.TurnosEstados.Llamado &&
                            turno.Id_Centro_Usuario == ctrl.usuarioConfig.Id_Centro_Usuario) {
                            ctrl.volverEstadoAnterior(turno)
                        }
                    }

                    //Sumatoria de turnos esperando
                    ctrl.EnEspera.Total = ctrl.EnEspera.Sin_Turno + ctrl.EnEspera.Con_Turno;
                }
            }

            ctrl.changeBloquearAcciones = function (value) {
                //esto se hace para que lance el $onChanges en las filas
                ctrl.bloquearAcciones = value;
            }

            ctrl.DerivacionModal = function (derivacion_Info) {
                let swalPromise = null;
                //Este metodo muestra el moda con la notificacion de que ha recibido una derivacion
                //Si el centro notifica las derivaciones "Notifica" == S y si la atencion del ciudadano no esta pausada, entonces entra
                if (derivacion_Info.Notifica == 'S' && !ctrl.PuestoPausado) {

                    //Verifica el tipo de derivacion
                    switch (derivacion_Info.Id_Tipo_Derivacion) {
                        case TurneroAppConstant.TipoDerivacion.Agenda:  //AGENDA

                            var mostrar = false;
                            var auxIDagenda = ctrl.Atencion.Agenda == 0 ? 0 : parseInt(ctrl.Atencion.Agenda.id)
                            //auxIDagenda == 0  -----> Cuando son todas las agendas
                            if (auxIDagenda == 0) {
                                for (var i = 0; i < ctrl.Agendas.length; i++) {
                                    var agenda = ctrl.Agendas[i];
                                    var auxIDagenda = parseInt(agenda.id);
                                    /// si encuentra la agenda en la lista de agendas del usuario 
                                    if (derivacion_Info.Id_Destino_Derivacion == auxIDagenda) {
                                        mostrar = true;
                                    }
                                }
                            }
                            else {
                                //la agenda seleccionada en el combo de arriba y Id_Destino_Derivacion (Id_Agenda) son iguales
                                if (auxIDagenda != 0 && derivacion_Info.Id_Destino_Derivacion == auxIDagenda) {
                                    mostrar = true;
                                }
                            }
                            //Muestra el mensaje
                            if (mostrar) {
                                swalPromise = swal({
                                    title: 'Ha recibido una derivación',
                                    html: "El agente " + derivacion_Info.N_Persona + " ha derivado en la agenda " + derivacion_Info.N_Agenda + ", el turno " + derivacion_Info.Nro_Ticket + " a nombre de " + derivacion_Info.N_Ciudadano + ", desde " + derivacion_Info.N_Puesto + ".<br/><br/>Podrá ver este turno en la pantalla de Atención, en el listado de turnos, con el estado Derivado.",
                                    type: 'info',
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                    allowEscapeKey: false
                                });
                            }
                            break
                        case TurneroAppConstant.TipoDerivacion.Grupo_Puestos: //GRUPO PUESTOS
                            if (ctrl.usuarioConfig.Id_Grupo_Puesto.length > 0 && ctrl.usuarioConfig.Id_Grupo_Puesto.indexOf(derivacion_Info.Id_Destino_Derivacion) > -1) {
                                swalPromise = swal({
                                    title: 'Ha recibido una derivación',
                                    html: "El agente " + derivacion_Info.N_Persona + " ha derivado al grupo ' " + derivacion_Info.Destino + " ', el turno " + derivacion_Info.Nro_Ticket + " a nombre de " + derivacion_Info.N_Ciudadano + ", desde " + derivacion_Info.N_Puesto + ", en la agenda " + derivacion_Info.N_Agenda + ".<br/><br/>Podrá ver este turno en la pantalla de Atención, en el listado de turnos, con el estado Derivado.",
                                    type: 'info',
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                    allowEscapeKey: false
                                });
                            }
                            break
                        case TurneroAppConstant.TipoDerivacion.Puesto: //PUESTOS
                            if (derivacion_Info.Id_Destino_Derivacion == parseInt(ctrl.PuestoSeleccionado.id)) { //Id_Destino_Derivacion (Id_Puesto)  == al puesto seleccionado en el combo
                                swalPromise = swal({
                                    title: 'Ha recibido una derivación',
                                    html: "El agente " + derivacion_Info.N_Persona + " ha derivado a su puesto el turno " + derivacion_Info.Nro_Ticket + " a nombre de " + derivacion_Info.N_Ciudadano + ", desde " + derivacion_Info.N_Puesto + ", en la agenda " + derivacion_Info.N_Agenda + ".<br/><br/>Podrá ver este turno en la pantalla de Atención, en el listado de turnos, con el estado Derivado.",
                                    type: 'info',
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                    allowEscapeKey: false
                                });
                            }
                            break

                    }
                }

                return swalPromise;
            };

            ctrl.muestraTurnoDetalle = function (bool) {
                //esta variable es utilizada para mostrar la grilla u ocultarla, en el caso de ocultarla se muestra el detalle del turno (para el estado atendido)
                ctrl.turnoDetalles = bool;
            }

            ctrl.postMovimientosAgenda = function (agenda) {
                //se ejecuta cuando el usuario seleciciona alguna agenda
                // Post Movimiento registra en que agenda va a estar trabajando el usuario logueado.
                // Si el Usuario Seleccionado todas las Agendas se envia "agenda" = 0 sino se envia el objeto de la agenda y en el post se envia el Id de la agenda.
                if (agenda || agenda == 0) {
                    var auxIDagenda = agenda == 0 ? 0 : parseInt(agenda.id);
                    var aux = ctrl.UsuarioConfig;
                    ctrl.UsuarioConfig = null;
                    
                    //ctrl.turnosEnEspera es un metodo que esta definido en el componente atencionListadoComponent
                    if (ctrl.turnosEnEspera)
                        ctrl.turnosEnEspera(auxIDagenda);
                    
                    usuariosService.Post_Movimiento_Usuario_Sesion({
                        'id_usuario_sesion': aux.Id_Usuario_Sesion,
                        'id_centro_usuario': aux.Id_Centro_Usuario,
                        'id_agenda': agenda == 0 ? null : agenda.id,
                        'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                    }).$promise.then(function (resultado) {
                        aux.Solo_Llamar_Proximo = resultado.Data.Llamar_Proximo == 'S' ? true : false;
                        aux.Llamador_Activo = resultado.Data.Llamador_Activo ? true : false;
                        aux.Id_Agenda = auxIDagenda;


                        ctrl.UsuarioConfig = aux;//Dispara el $onChanges en el componente de la grilla
                        ctrl.muestraTurnoDetalle(false);
                    }).catch(function (error) {
                        utilsService.errores(error);
                        if (error.data && error.data.IsUserSessionException) {
                            ctrl.limpiarMemoria();
                        } else {
                            ctrl.UsuarioConfig = aux;
                        }
                    })
                }
            }

            ctrl.validarAgendaTurno = function (turno) {
                //si selecciono todas las agendas
                if (ctrl.Atencion.Agenda == 0) {
                    var idx = ctrl.Agendas.findIndex(x => {
                        //si la ultima derivacion fue por agenda verifico que pertenezca a esta
                        if (turno.Agenda_Destino_Deriv)
                            return x.id == turno.Agenda_Destino_Deriv;
                        //si no busco si pertenece a la agenda original
                        else
                            return x.id == turno.Id_Agenda
                    })
                    return idx != -1;
                }
                //si tiene una agenda seleccionada
                else if (ctrl.Atencion.Agenda) {
                    //si la ultima derivacion fue por agenda verifico que pertenezca a esta
                    if (turno.Agenda_Destino_Deriv)
                        return turno.Agenda_Destino_Deriv == ctrl.Atencion.Agenda.id;
                    //si no busco si pertenece a la agenda original
                    else
                        return turno.Id_Agenda == ctrl.Atencion.Agenda.id;
                } else
                    return false
            }

            ctrl.validarAgendaTurnoDerivado = function (turno) {
                if (ctrl.Atencion.Agenda == 0) {
                    return ctrl.Agendas.findIndex(x => {
                        return x.id == turno.Agenda_Destino_Deriv
                    }) == -1 ? false : true;
                } else if (ctrl.Atencion.Agenda) {
                    return turno.Agenda_Destino_Deriv == ctrl.Atencion.Agenda.id;
                } else
                    return false
            }

            ctrl.validarDerivadoAMi = function (Turno) {
                if (!ctrl.usuarioConfig)
                    return false;

                return (ctrl.validarAgendaTurnoDerivado(Turno) ||
                    ((ctrl.usuarioConfig.Id_Grupo_Puesto.length > 0 && ctrl.usuarioConfig.Id_Grupo_Puesto.indexOf(Turno.Grupo_Destino_Deriv) > -1) ||
                        Turno.Id_Usu_Sesion_Deriv == ctrl.usuarioConfig.Id_Usuario_Sesion) &&
                    ctrl.validarAgendaTurno(Turno));
            }

            ctrl.notificacionPushAnunciado = function (turno) {
                if (ctrl.usuarioConfig.notificarNuevosTurnos) {
                    if (Push.Permission.DEFAULT) {
                        Push.Permission.request(ctrl.mostrarNotificacion(turno), ctrl.mensajePermisosNotificacion);
                    }
                    else if (Push.Permission.DENIED) {
                        ctrl.mensajePermisosNotificacion();
                    }
                }
            }

            //Obtener grilla de atencion
            ctrl.getAtencionGrilla = function () {
                // FIX TMC-1412: Mejorar validación y feedback al usuario
                if (!ctrl.usuarioConfig || !ctrl.usuarioConfig.Id_Usuario_Sesion) {
                    console.warn('[sidebarAtencion.getAtencionGrilla] No se encontró sesión de usuario válida', {
                        usuarioConfig: ctrl.usuarioConfig,
                        centroAtencion: ctrl.centroAtencionSeleccionado ? ctrl.centroAtencionSeleccionado.id : null,
                        url: $location.path()
                    });
                    
                    // Mostrar mensaje al usuario en lugar de retornar silenciosamente
                    swal({
                        title: 'Atención',
                        html: 'No se encontró una sesión válida. Por favor, seleccione nuevamente el puesto y la agenda.',
                        type: 'warning',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: "Aceptar",
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    }).then(function() {
                        $state.go('sidebar.sidebarAtencionConfig');
                    });
                    return;
                }

                ctrl.bloquearAcciones = true;
                ctrl.cargandoGrilla = true; // muestra el loading
                
                console.info('[sidebarAtencion.getAtencionGrilla] Obteniendo turnos de atención', {
                    idUsuarioSesion: ctrl.usuarioConfig.Id_Usuario_Sesion,
                    idCentroUsuario: ctrl.usuarioConfig.Id_Centro_Usuario,
                    url: $location.path()
                });
                
                turnosService.Get_Turnos_Atencion({ 'Id_Usuario_Sesion': ctrl.usuarioConfig.Id_Usuario_Sesion })
                    .$promise.then(function (resultado) {
                        console.info('[sidebarAtencion.getAtencionGrilla] Turnos obtenidos exitosamente', {
                            cantidad: resultado.Data ? resultado.Data.length : 0,
                            idUsuarioSesion: ctrl.usuarioConfig.Id_Usuario_Sesion
                        });
                        
                        var Turnos = resultado.Data;
                        ctrl.Turnos = [];

                        for (var i = 0; i < Turnos.length; i++) {
                            ctrl.mostrarTurnoAtencion(Turnos[i]);
                        }

                        if (ctrl.turnosEnEspera) {
                            if (ctrl.Atencion.Agenda || ctrl.Atencion.Agenda == 0) {
                                var auxIDagenda = ctrl.Atencion.Agenda == 0 ? 0 : parseInt(ctrl.Atencion.Agenda.id);
                                ctrl.turnosEnEspera(auxIDagenda);
                            }
                        }

                        ctrl.cargandoGrilla = false;
                        ctrl.bloquearAcciones = false;
                        ctrl.onLoading = false;

                        if (ctrl.usuarioConfig.notificarTiempoEsperaExcedido && !ctrl.intervalTiemposDeEsperaExcedidosTemporizado)
                        {
                            ctrl.activarControlTiemposDeEsperaExcedidos();
                        }
                    }).catch(function (error) {
                        // FIX TMC-1412: Agregar logs detallados antes de procesar el error
                        console.error('[sidebarAtencion.getAtencionGrilla] Error al obtener turnos de atención', {
                            error: error,
                            status: error.status,
                            statusText: error.statusText,
                            data: error.data,
                            idUsuarioSesion: ctrl.usuarioConfig ? ctrl.usuarioConfig.Id_Usuario_Sesion : null,
                            url: $location.path()
                        });
                        
                        ctrl.cargandoGrilla = false;
                        ctrl.bloquearAcciones = false;
                        
                        utilsService.errores(error, function () {
                            ctrl.limpiarMemoria();
                        });
                    })
            };

            ctrl.getTiemposDeEsperaExcedidos = function () {
                turnoExcedidoNotificacion = null;
                for (var i = 0; i < ctrl.Turnos.length; i++) {
                    if (ctrl.validarTiempoDeEspera(ctrl.Turnos[i]) > ctrl.Turnos[i].Duracion_Turno && ctrl.Turnos[i].Id_Estado !== ctrl.TurnosEstados.Atendido) {
                        if (turnoExcedidoNotificacion === null) {
                            turnoExcedidoNotificacion = ctrl.Turnos[i].N_Agenda;
                        }
                        else {
                            var nombreAgendaTiempoEsperaExcedido = turnoExcedidoNotificacion.split("|");
                            for (var j = 0; j < nombreAgendaTiempoEsperaExcedido.length; j++) {
                                if (nombreAgendaTiempoEsperaExcedido[j] === ctrl.Turnos[i].N_Agenda) {
                                    existe = true;
                                    break;
                                }
                            }

                            if (!existe) {
                                turnoExcedidoNotificacion = turnoExcedidoNotificacion + "|" + ctrl.Turnos[i].N_Agenda;
                            }
                        }
                    }
                }

                if (turnoExcedidoNotificacion !== null) {
                    ctrl.notificacionTiempoEsperaExcedidoPush(turnoExcedidoNotificacion.replace("|", ", "));
                }
            }

            ctrl.validarTurnoAtendidoPorMi = function () {
                var flag = false;

                for (var i = 0; i < ctrl.Turnos.length; i++) {
                    var turno = ctrl.Turnos[i];
                    //Si el turno esta atendido por mi 
                    if (turno.Id_Estado == ctrl.TurnosEstados.Atendido && turno.Id_Centro_Usuario == ctrl.usuarioConfig.Id_Centro_Usuario) {
                        flag = true;
                    }
                }

                ctrl.TurnoAtendidoPorMi = flag;
            };

            ctrl.validarTurnoParaMiPuesto = function (Turno) {
                //validaciones para saber si el turno esta asignado a mi puesto
                if (!ctrl.usuarioConfig)
                    return false;

                //me fijo si el turno está derivado a mi
                if (Turno.Id_Estado == ctrl.TurnosEstados.Derivado && ctrl.validarDerivadoAMi(Turno)) {
                    return true;
                }

                //Si esta atendido , retenido o llamado por mi
                if (Turno.Id_Centro_Usuario == ctrl.usuarioConfig.Id_Centro_Usuario && (Turno.Id_Estado == ctrl.TurnosEstados.Retenido || Turno.Id_Estado == ctrl.TurnosEstados.Atendido || Turno.Id_Estado == ctrl.TurnosEstados.Llamado)) {
                    return true;
                }

                //No esta asignado a mi puesto
                return false;
            }

            ctrl.validarDerivadoAMi = function (Turno) {
                if (!ctrl.usuarioConfig)
                    return false;

                return (ctrl.validarAgendaTurnoDerivado(Turno) ||
                    ((ctrl.usuarioConfig.Id_Grupo_Puesto.length > 0 && ctrl.usuarioConfig.Id_Grupo_Puesto.indexOf(Turno.Grupo_Destino_Deriv) > -1) ||
                        Turno.Id_Usu_Sesion_Deriv == ctrl.usuarioConfig.Id_Usuario_Sesion) &&
                    ctrl.validarAgendaTurno(Turno));
            }

            ctrl.DerivacionModal = function (derivacion_Info) {
                let swalPromise = null;
                //Este metodo muestra el moda con la notificacion de que ha recibido una derivacion
                //Si el centro notifica las derivaciones "Notifica" == S y si la atencion del ciudadano no esta pausada, entonces entra
                if (derivacion_Info.Notifica == 'S' && !ctrl.PuestoPausado) {

                    //Verifica el tipo de derivacion
                    switch (derivacion_Info.Id_Tipo_Derivacion) {
                        case TurneroAppConstant.TipoDerivacion.Agenda:  //AGENDA

                            var mostrar = false;
                            var auxIDagenda = ctrl.Atencion.Agenda == 0 ? 0 : parseInt(ctrl.Atencion.Agenda.id)
                            //auxIDagenda == 0  -----> Cuando son todas las agendas
                            if (auxIDagenda == 0) {
                                for (var i = 0; i < ctrl.Agendas.length; i++) {
                                    var agenda = ctrl.Agendas[i];
                                    var auxIDagenda = parseInt(agenda.id);
                                    /// si encuentra la agenda en la lista de agendas del usuario 
                                    if (derivacion_Info.Id_Destino_Derivacion == auxIDagenda) {
                                        mostrar = true;
                                    }
                                }
                            }
                            else {
                                //la agenda seleccionada en el combo de arriba y Id_Destino_Derivacion (Id_Agenda) son iguales
                                if (auxIDagenda != 0 && derivacion_Info.Id_Destino_Derivacion == auxIDagenda) {
                                    mostrar = true;
                                }
                            }
                            //Muestra el mensaje
                            if (mostrar) {
                                swalPromise = swal({
                                    title: 'Ha recibido una derivación',
                                    html: "El agente " + derivacion_Info.N_Persona + " ha derivado en la agenda " + derivacion_Info.N_Agenda + ", el turno " + derivacion_Info.Nro_Ticket + " a nombre de " + derivacion_Info.N_Ciudadano + ", desde " + derivacion_Info.N_Puesto + ".<br/><br/>Podrá ver este turno en la pantalla de Atención, en el listado de turnos, con el estado Derivado.",
                                    type: 'info',
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                    allowEscapeKey: false
                                });
                            }
                            break
                        case TurneroAppConstant.TipoDerivacion.Grupo_Puestos: //GRUPO PUESTOS
                            if (ctrl.usuarioConfig.Id_Grupo_Puesto.length > 0 && ctrl.usuarioConfig.Id_Grupo_Puesto.indexOf(derivacion_Info.Id_Destino_Derivacion) > -1) {
                                swalPromise = swal({
                                    title: 'Ha recibido una derivación',
                                    html: "El agente " + derivacion_Info.N_Persona + " ha derivado al grupo ' " + derivacion_Info.Destino + " ', el turno " + derivacion_Info.Nro_Ticket + " a nombre de " + derivacion_Info.N_Ciudadano + ", desde " + derivacion_Info.N_Puesto + ", en la agenda " + derivacion_Info.N_Agenda + ".<br/><br/>Podrá ver este turno en la pantalla de Atención, en el listado de turnos, con el estado Derivado.",
                                    type: 'info',
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                    allowEscapeKey: false
                                });
                            }
                            break
                        case TurneroAppConstant.TipoDerivacion.Puesto: //PUESTOS
                            if (derivacion_Info.Id_Destino_Derivacion == parseInt(ctrl.PuestoSeleccionado.id)) { //Id_Destino_Derivacion (Id_Puesto)  == al puesto seleccionado en el combo
                                swalPromise = swal({
                                    title: 'Ha recibido una derivación',
                                    html: "El agente " + derivacion_Info.N_Persona + " ha derivado a su puesto el turno " + derivacion_Info.Nro_Ticket + " a nombre de " + derivacion_Info.N_Ciudadano + ", desde " + derivacion_Info.N_Puesto + ", en la agenda " + derivacion_Info.N_Agenda + ".<br/><br/>Podrá ver este turno en la pantalla de Atención, en el listado de turnos, con el estado Derivado.",
                                    type: 'info',
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                    allowEscapeKey: false
                                });
                            }
                            break

                    }
                }

                return swalPromise;
            }

            // Función para cargar agendas sin iniciar sesión (para restauración)
            ctrl.cargarAgendas = function (puesto) {
                return agendaService.Get_Agendas_Combo_Atencion({
                    'id_centro_usuario': puesto.Id_Centro_Usuario
                }).$promise.then(function (resultado) {
                    ctrl.Agendas = resultado.Data;
                    return resultado.Data;
                }).catch(function (error) {
                    utilsService.errores(error);
                    throw error;
                });
            };

            // Función async para inicializar el componente
            ctrl.inicializarComponente = async function() {
                if(ctrl.Atencion.Puesto && ctrl.centroAtencionSeleccionado){
                    
                        
                await ctrl.cargarAgendas(ctrl.Atencion.Puesto);
                }
            };
            
            ctrl.inicializarComponente();

            //ACCION TEMPORIZADA TIEMPO DE ESPERA EXCEDIDO
            ctrl.controlarTiemposDeEsperaExcedidos = function () {
                ctrl.getTiemposDeEsperaExcedidos();
            }

            ctrl.activarControlTiemposDeEsperaExcedidos = function () {
                ctrl.controlarTiemposDeEsperaExcedidos();
                if (!ctrl.intervalTiemposDeEsperaExcedidosTemporizado) {
                    ctrl.intervalTiemposDeEsperaExcedidosTemporizado = $interval(ctrl.controlarTiemposDeEsperaExcedidos, TurneroAppConstant.HubDisconnectedIntervals.Atencion);
                }
            }

            ctrl.desactivarControlTiemposDeEsperaExcedidos = function () {
                if (ctrl.intervalTiemposDeEsperaExcedidosTemporizado) {
                    //cancelo el intervalo
                    $interval.cancel(ctrl.intervalTiemposDeEsperaExcedidosTemporizado);
                    ctrl.intervalTiemposDeEsperaExcedidosTemporizado = undefined;

                    //llamo por ultima vez a las acciones para que queden actualizadas
                    ctrl.controlarTiemposDeEsperaExcedidos();
                }
            }

            //ACCIONES TEMPORIZADAS
            ctrl.accionesTemporizadas = function () {
                ctrl.traerTurnos();
                //console.info('Actualización temporizada.')
            }

            ctrl.activarAccionesTemporizadas = function () {
                //este if está para que se cree un solo interval y pueda ser capturado para luego cerrarse
                if (!ctrl.intervalAccionesTemporizadas) {
                    ctrl.intervalAccionesTemporizadas = $interval(ctrl.accionesTemporizadas, TurneroAppConstant.HubDisconnectedIntervals.Atencion);
                }
            }

            ctrl.desactivarAccionesTemporizadas = function () {
                if (ctrl.intervalAccionesTemporizadas) {
                    //cancelo el intervalo
                    $interval.cancel(ctrl.intervalAccionesTemporizadas);
                    ctrl.intervalAccionesTemporizadas = undefined;

                    //llamo por ultima vez a las acciones para que queden actualizadas
                    ctrl.accionesTemporizadas();
                }
                if (ctrl.intervalTiemposDeEsperaExcedidosTemporizado) {
                    //cancelo el intervalo
                    $interval.cancel(ctrl.intervalTiemposDeEsperaExcedidosTemporizado);
                    ctrl.intervalTiemposDeEsperaExcedidosTemporizado = undefined;

                    //llamo por ultima vez a las acciones para que queden actualizadas
                    ctrl.controlarTiemposDeEsperaExcedidos();
                }
            }

            ctrl.getAtencionGrilla();
            // Conectar SignalR para recibir actualizaciones en tiempo real (MostrarTurnoAtencion, etc.)
            ctrl.SignalRConnect();

            $scope.$on('AfterHubConnectionStart', function (event, hub) {
                //a TurnosHub lo agrega al Grupo del centro de atencion.
                hub.invoke('AgregarGrupo', ctrl.centroAtencionSeleccionado.id).then(function () {
                    console.info("Se invocó a AgregarGrupo en " + hub.connection.baseUrl + ".");
                }).catch(function (err) {
                    console.error("Falló invocación a AgregarGrupo en " + hub.connection.baseUrl + ": " + err.toString());
                });

                //cuando se conecta al hub detengo las acciones temporizadas
                ctrl.desactivarAccionesTemporizadas();

                //evito los warnings de los hub que no tengo que escuchar
                //escucho el evento pero no hago nada
                hub.on("MostrarTurno", function () { });
                //escucho el evento pero no hago nada
                hub.on("EliminarTurno", function () { });
                //escucho el evento pero no hago nada
                hub.on("TraerPuestos", function () { });
                //escucho el evento pero no hago nada
                hub.on("MostrarPuesto", function () { });
                //escucho el evento pero no hago nada
                hub.on("UltimoTurnoAtendido", function () { });
            });

            //cuando se desconecta el hub realizo las acciones temporizadas
            $scope.$on('AfterHubConnectionClose', function (event, hub) {
                ctrl.activarAccionesTemporizadas();
            });
        }],
    template: require('./sidebarAtencion.html')


});





// WEBPACK FOOTER //
// ./app/components/atencion/sidebarAtencionComponent.js